export const totalItem=()=>{
    return{
        type:"TOTAL_ITEM"
        
    }
}